import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { GlobalService } from '../core/global.service';
import { Person } from './models/person';

@Injectable({
  providedIn: 'root'
})
export class PersonService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'eqcpcc': this._global.find((<any>_GlobalNS).paths.eqcpcc)
    })
  };

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  findByEmail(email: string):  Observable<any> {
    const getApi = (<any>_GlobalNS).api.partner.searchByEmail;
    const params = new HttpParams().set('email', email).set('relationshipID', this._global.find((<any>_GlobalNS).paths.RelationshipId));
    this.httpOptions['params'] = params;
    return this._http.get(`${getApi}`, this.httpOptions);
  }

  findById(PersonId: number): Observable<any> {
    const params = new HttpParams().set('PersonId', PersonId.toString());
    this.httpOptions['params'] = params;
    return this._http.get<any>(`${(<any>_GlobalNS).api.person.getById}`, this.httpOptions);
  }

  findByEmailOption(PersonId: number): Observable<any> {
    const params = new HttpParams().set('PersonId', PersonId.toString());
    this.httpOptions['params'] = params;
    return this._http.get<any>(`${ (<any>_GlobalNS).api.person.emailOption}`, this.httpOptions);
  }

  updateEmailOption(Data: any): Observable<any> {
    const api = (<any>_GlobalNS).api.person.emailOption;
    const params = new HttpParams().set('eqrf', this._global.find((<any>_GlobalNS).paths.eqrf));
    this.httpOptions['params'] = params;
    return this._http.post<any>(`${api}`, Data , this.httpOptions);
  }

  update(Data: any): Observable<any> {
    const api = (<any>_GlobalNS).api.person.update;
    const params = new HttpParams().set('eqrf', this._global.find((<any>_GlobalNS).paths.eqrf));
    this.httpOptions['params'] = params;
    return this._http.post<any>(`${api}`, Data , this.httpOptions);
  }

  sendEmail(PersonId: number,resetPassword?: boolean): Observable<any> {
    const api = (<any>_GlobalNS).api.general.sendEmail;
    const params = new HttpParams().set('PersonId', PersonId.toString())
                                   .set('eqrf', this._global.find((<any>_GlobalNS).paths.eqrf))
                                   .set('resetPassword', ((resetPassword != null || resetPassword != undefined) ? 'true' : 'false'));

    this.httpOptions['params'] = params;
    return this._http.post<any>(`${api}`, {} , this.httpOptions);
  }

  getFullName(person: Person): string {
    return ((<any>person).FirstName === (undefined || null) || (<any>person).FirstName.length <= 0)
    ? null : `${(<any>person).FirstName} ${(<any>person).LastName}`;
  }
}
